import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CalendarDate, getMonthFromDate, getNextMonth, getPreviousMonth, useAppContext, } from '@datapad/data-model';
import { Box } from '@mui/material';
import React from 'react';
import { CalendarGrid, CalendarToolbar, DayModal } from './components/index.js';
import { useEventsForMonth } from './hooks/index.js';
function generateDatesForMonth(year, startDay, dayCount) {
    const dates = [];
    for (let i = 0; i < dayCount; i++) {
        dates.push(CalendarDate.create(year, startDay + i));
    }
    return dates;
}
export function Calendar(props) {
    const { currentDate, selectedMonth, onMonthChange } = props;
    const appContext = useAppContext();
    const goToPreviousMonth = React.useCallback(() => {
        onMonthChange(getPreviousMonth(selectedMonth));
    }, [onMonthChange, selectedMonth]);
    const goToNextMonth = React.useCallback(() => {
        onMonthChange(getNextMonth(selectedMonth));
    }, [onMonthChange, selectedMonth]);
    const goToToday = React.useCallback(() => {
        if (currentDate) {
            onMonthChange(getMonthFromDate(currentDate));
        }
    }, [onMonthChange, currentDate]);
    const isViewingCurrentMonth = currentDate !== undefined &&
        selectedMonth.year === currentDate.year &&
        currentDate.day >= selectedMonth.startDay &&
        currentDate.day < selectedMonth.startDay + selectedMonth.dayCount;
    const [selectedDate, setSelectedDate] = React.useState(undefined);
    const isModalOpen = selectedDate !== undefined;
    const datesInMonth = React.useMemo(() => generateDatesForMonth(selectedMonth.year, selectedMonth.startDay, selectedMonth.dayCount), [selectedMonth.year, selectedMonth.startDay, selectedMonth.dayCount]);
    const visibleEvents = appContext.getVisibleEvents();
    const eventsInMonth = useEventsForMonth(visibleEvents, selectedMonth);
    const visibleBirthdays = appContext.getVisibleBirthdays();
    const selectedDateEvents = React.useMemo(() => {
        if (!selectedDate)
            return [];
        return eventsInMonth.filter((event) => event.date.equals(selectedDate));
    }, [selectedDate, eventsInMonth]);
    const selectedDateBirthdays = React.useMemo(() => {
        if (!selectedDate)
            return [];
        return visibleBirthdays.filter((character) => character.birthday?.day === selectedDate.day);
    }, [selectedDate, visibleBirthdays]);
    const handleDateClick = React.useCallback((date) => {
        setSelectedDate(date);
    }, []);
    const handleModalClose = React.useCallback(() => {
        setSelectedDate(undefined);
    }, []);
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box',
        }, children: [_jsx(CalendarToolbar, { month: selectedMonth, onPreviousMonth: goToPreviousMonth, onNextMonth: goToNextMonth, onToday: currentDate !== undefined ? goToToday : undefined, todayDisabled: isViewingCurrentMonth }), _jsx(Box, { sx: { flex: 1, overflow: 'auto', minWidth: 0 }, children: _jsx(CalendarGrid, { dates: datesInMonth, events: eventsInMonth, characters: visibleBirthdays, currentDate: currentDate, onDateClick: handleDateClick }) }), _jsx(DayModal, { date: selectedDate, events: selectedDateEvents, birthdays: selectedDateBirthdays, open: isModalOpen, onClose: handleModalClose })] }));
}
//# sourceMappingURL=Calendar.js.map